export default "__VITE_ASSET__DwZb$iKE__"